import './TrainersList.scss';
import Control from "../1. Core/Control";
import NP, {ValueChangedEventArgs} from "../1. Core/NP";
import TopAppBar from "../1. Core/Controls/TopAppBar/TopAppBar";
import Delegate from "../1. Core/Delegate";
import {ServerAPI} from "../1. Core/ServerAPI";
import DataTable from "../1. Core/Controls/DataTable/DataTable";
import IconToggleButton from "../1. Core/Controls/IconToggleButton/IconToggleButton";
import Menu from "../1. Core/Controls/Menu/Menu";
import {Trainer} from "../10. Battle/types";
import EditTrainerDialog from "./EditTrainerDialog";
import TrainerPanel from "./TrainerPanel";


export default class TrainersList extends Control {
	private _Count: number;
	private _Offset: number;
	private _topAppBar: TopAppBar;
	private _FilterText: string;
	private EvShowPageModeClick: Delegate;
	private EvPageModeChanged: Delegate;
	private items: Trainer[];
	private _dataTable: DataTable;


	private _dataWithFiltersNode: HTMLElement;

	private trainerContentNode: HTMLElement;
	private trainerPanel: TrainerPanel;
	private _StateId: number;

	constructor(settings: object)
	{

		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this._StateId = null;
		this.EvShowPageModeClick = new Delegate();
		this.EvPageModeChanged = new Delegate();
		this._FilterText = '';
		super._initFields(settings);
	}

	_render()
	{
		this.np_render();

		this._Count = 100;
		this._Offset = 0;

		this.trainerContentNode = NP.createNode(this._root);

		this._topAppBar = new TopAppBar({
			Class: 'top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
			Caption: NP.RM.getString('Trainers'),
			ParentNode: this.trainerContentNode,
			EvSearch: (s: Control, e: ValueChangedEventArgs) =>
			{
				this._FilterText = e.Value;
				this._Offset = 0;
				this._refreshList();
			},
			EvHideSearch: () =>
			{
				this._Offset = 0;
				this._FilterText = null;
				this._refreshList();
			},
			ShowSearchButton: false,
			MainButton: {
				FontImage: NP.FontImages.menu,
				EvClick: () => this.EvShowPageModeClick.fire(this)
			},
			EvFocusSearch: () =>
			{
			}
		});

		if (NP.isAdmin())
			this._topAppBar.addItem(new IconToggleButton({
				FontImage: NP.FontImages.add,
				Value: 'AddTrainer',
				RK: 'AddTrainer',
				EvClick: () => (new EditTrainerDialog({
					EvChanged: () => this.refresh()
				})).show()
			}));

		// this._topAppBar.addItem(new IconToggleButton({
		// 	FontImage: NP.FontImages.tune,
		// 	Value: 'Filters',
		// 	EvClick: (btn: IconToggleButton) =>
		// 	{
		// 		btn.setData(!btn.getData())
		//
		// 		this.setWidth(this._Width);
		// 	}
		// }));


		this._dataWithFiltersNode = NP.createNode(this.trainerContentNode, 'data-with-filters-container');

		this._dataTable = new DataTable({
			ParentNode: this._dataWithFiltersNode,
			ShowSettingsButton: NP.isAdmin(),
			Class: 'app-list--avatars mdc-data-table--margin data-table-battle',
			MultiSelect: false,
			ShowRowIndex: true,
			ImageWidth: 32,
			Columns: [{
				Content: NP.RM.getString('Name'),
				Width: '25%',
				PropertyContent: 'Name'
			}, {
				Content: NP.RM.getString('Region'),
				PropertyContent: 'Region',
				Width: '25%'
			}, !NP.isTha() && {
				Content: NP.RM.getString('SportClub'),
				PropertyContent: 'Club',
				Width: '25%'
			}, {
				Content: NP.RM.getString('Rating'),
				Width: '20%',
				PropertyContent: 'Rating'
			}, {
				Content: NP.RM.getString('StudentCount'),
				Width: '5%',
				PropertyContent: 'AthleteCount'
			}],
			ShowPaginator: false,
			EvPaginatorLeftClick: () =>
			{
				this._Offset -= this._Count;
				this._refreshList();
			},
			EvPaginatorRightClick: () =>
			{
				this._Offset += this._Count;
				this._refreshList();
			},
			EvItemContextMenu: (s: any, e: { Event: any, Item: Trainer }) =>
			{
				if (NP.isAdmin())
				{
					let menu = new Menu({
						Items: [{
							FontImage: NP.FontImages.edit,
							RK: 'Edit',
							Value: 'Edit'
						}, {
							FontImage: NP.FontImages.delete,
							RK: 'Delete',
							Value: 'Delete'
						}],
						EvItemSelected: (s: Menu, event: { Item: any }) =>
						{
							switch (event.Item.getValue())
							{
								case 'Delete':
									ServerAPI.delet(`/trainers/${e.Item.Id}`).then(() => this.refresh());
									break;
								case 'Edit':
									(new EditTrainerDialog({
										Trainer: e.Item,
										EvChanged: () => this.refresh()
									})).show();
									break;
							}
						}
					});
					menu.showContextMenu(e.Event);
				}
			},
			EvSelectionChanged: () =>
			{
			},
			EvScrolled: (s: DataTable, e: any) => this._onScrolled(s, e),
			EvItemClick: (s: object, e: { Item: Trainer }) =>
			{
				if (!this._StateId)
					this.onTrainerClicked(e.Item)
			}
		});

	}

	_onScrolled(s: DataTable, e: any)
	{
		if (e.scroll > 0 && e.isSmall)
			this._topAppBar.addClass('top-app-bar--fixed-scrolled');
		else
			this._topAppBar.removeClass('top-app-bar--fixed-scrolled');
	}

	refresh()
	{
		this._refreshList();

		this._onScrolled(null, {
			scroll: 0,
			isSmall: this._dataTable.getIsSmall()
		});
	}

	async _refreshList()
	{
		this._dataTable.setRows([]);

		let filter = "";
		if (this._StateId)
			filter = `?stateId=${this._StateId}`;
		let trainers = await ServerAPI.get<Trainer[]>(`/trainers${filter}`);
		this.items = trainers.map((t, idx) => ({
			...t,
			Name: (t.LastName + ' ' + (t.FirstName ? t.FirstName : '')).trim()
		}))

		this._dataTable.setRows(this.items);
	}

	_getContentHeight()
	{
		return this._Height - this._topAppBar.getOffsetHeight();
	}

	setHeight(value: number)
	{
		super.setHeight(value);
		let h = this._getContentHeight();
		this._dataTable.setHeight(h);

		if (this.trainerPanel)
			this.trainerPanel.setHeight(value);
	}

	setWidth(value: number)
	{
		super.setWidth(value);
		this._dataTable.setWidth(value);


		if (this._dataTable.getIsSmall())
		{
			this._topAppBar.removeClass('top-app-bar--no-shadow');
			this.setHeight(this._Height);
		}
		else
		{
			this._topAppBar.addClass('top-app-bar--no-shadow');
			this.setHeight(this._Height);
		}

		if (this.trainerPanel)
			this.trainerPanel.setWidth(value);
	}

	getTopAppBar()
	{
		return this._topAppBar;
	}


	onTrainerClicked(trainer: Trainer)
	{

		NP.hideNode(this.trainerContentNode);

		this.trainerPanel = new TrainerPanel({
			ParentNode: this._root,
			Trainer: trainer,
			Width: this._Width,
			Height: this._Height
		})

		this.trainerPanel.getTopAppBar().EvBackClick.add(() =>
		{
			NP.showNode(this.trainerContentNode);
			this.trainerPanel.destroy();
			this.trainerPanel = null;
		}, this)

	}

}